export default {
  notVeBatch: {
    service:
      'You have not subscribed to the video batch production service, please contact sales.',
  },
  validateMessage: 'Only can contain numbers, letters, underscore',
  form: {
    setting: {
      min: 'Minimum',
      max: 'Maximum',
    },
  },
  back: 'Back',
  projectName: 'Project Name',
  editProject: {
    label: 'Rename',
    form: {
      name: {
        placeholder: 'Please input Project Name',
        empty: 'The Project Name cannot be empty.',
      },
    },
  },
  editVersion: {
    label: 'Rename',
    form: {
      name: {
        placeholder: 'Please input Version Name',
        empty: 'The Version Name cannot be empty.',
      },
    },
  },
  copyLink: 'Copy Link',
  copied: 'Copied',
  listEmpty: 'No Data',
  creativeInfo: {
    form: {
      direction: {
        tips: 'Modifications are not supported after creation. Select and edit again after duplicating the project.',
      },
    },
  },
  common: {
    model: {
      cocos: {
        rule: {
          size: 'File size exceeds 1M.',
          filenum: "Number of zip files doesn't match.",
          name: 'File name or suffix case is inconsistent.',
        },
      },
    },
    button: {
      close: 'Close',
    },
    form: {
      inputTips: 'Please enter',
      checkTips: 'Please Check',
    },
  },
  productSelector: {
    selectTips: 'Choose Promoted Product',
    select: 'Select',
    handler: 'Choose from Assets',
  },
  create: {
    name: 'Create',
    successful: 'Create Successfully',
  },
  hint: 'Tip',
  fold: 'Fold',
  more: 'More',
  templatel: {
    delete: {
      noadd: "This can't be undone. Are you sure to delete?",
    },
  },
  noresults: 'No Result',
  download: 'Download',
  push: 'Apply',
  noData: 'No Data',
  choice: 'Please Choose',
  search: {
    noresult:
      'Sorry, no eligible results were found. It is suggested to change to different search criteria.',
    text: 'Search',
  },
  trial: {
    application: 'Start Free Trial',
  },
  notsubscribed: {
    service: 'You have not subscribed to this service, please contact sales.',
  },
  cancel: 'Cancel',
  submit: 'Submit',
  startupload: 'Start Upload',
  startdownload: 'Start Download',
  confirm: 'Confirm',
  OK: 'Confirm',
  apply: 'Start',
  gotit: 'Got it',
  operate: {
    successful: 'Successfully',
  },
  delete: {
    successful: 'Delete Successfully',
  },
  update: {
    successful: 'Update Successfully',
  },
  add: {
    uccessful: 'Add Successfully',
  },
  storagefull: {
    tips: 'The storage is full and cannot be operated. Please clean up the asset library or contact sales for space expansion.',
  },
  copy: {
    successful: 'Copy Successfully',
  },
  reset: 'Reset',
  custom: 'Customize',
  plPoint: {
    list: {
      title: 'Tracking Log',
    },
    point: {
      gs: 'PL View',
      fc: 'First Interaction',
      ge: 'Game End',
      is: 'Redirect',
      scene: 'Scene {num}',
    },
    pointType: {
      base: 'Basic Tracking',
      custom: 'Custom Tracking',
    },
  },
}
